import { InputAdornment, Stack, Typography } from '@mui/material';
import Table, { Object } from 'components/Common/StyledTable';
import TextInput from 'components/Common/TextInput';

import { DateFilter, type DateFilterValue } from './DateFilter';
import { ReactElement } from 'react';
interface ParishonerActivityProps {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type -- pre-existing prop signature
    navigationHandler: Function;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- pre-existing prop signature
    records: Array<any>;
    columns: Array<{ id: string; label: string }>;
    textInputPlaceholders?: Array<string>;
    showDeleteCell?: boolean;
    /** Suppress the "Recent Activity"/date-filter header independently of showDeleteCell, for
     *  a table (e.g. a member list) that reuses this layout but isn't a date-filtered feed. */
    hideActivityHeader?: boolean;
    onDeleteClick?: (value: Object) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- pre-existing prop signature
    setFilter?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- pre-existing prop signature
    filter?: any;
    defaultPagination?: boolean;
    disabledDateFilter?: boolean;
    /** Option the date filter starts on (default 'today'); must match the consumer's initial `filter`. */
    dateFilterDefault?: DateFilterValue;
    /** Replaces the default "No results found." when the list is empty; `null` shows nothing. */
    emptyMessage?: string | null;
    /** Rows aren't clickable (no detail screen to go to). */
    disableRowNavigation?: boolean;
    value?: string | number;
    onTemplatebuttonclick?: () => void;
    getStartedTemplate?: boolean;
    templateButtonText?: string;
    loading?: boolean;
    serverSidePagination?: boolean;
    totalCount?: number;
    activityHeader?: ReactElement;
    showLoading?: boolean;
}

function ActivityContainer({
    navigationHandler,
    records,
    columns,
    textInputPlaceholders,
    showDeleteCell,
    hideActivityHeader,
    onDeleteClick,
    setFilter,
    filter,
    defaultPagination,
    disabledDateFilter,
    dateFilterDefault,
    emptyMessage,
    disableRowNavigation,
    value,
    onTemplatebuttonclick,
    getStartedTemplate,
    templateButtonText,
    loading,
    serverSidePagination,
    totalCount,
    activityHeader,
    showLoading,
}: ParishonerActivityProps) {
    const hideHeader = showDeleteCell || hideActivityHeader;
    return (
        <Stack px={2} sx={{ backgroundColor: 'white', width: '100%' }}>
            <div style={{ paddingTop: 8, marginTop: 8 }}>
                {/* TODO:  Remove the turnery operator operator and implement activity header in whole app */}
                {activityHeader ? (
                    activityHeader
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 12 }}>
                        <TextInput
                            backgroundColor="#F2F2F6"
                            height={50}
                            width={'30%'}
                            icon={null}
                            disabled
                            placeholder={textInputPlaceholders?.[0]}
                            InputProps={{
                                endAdornment: !loading && <InputAdornment position="end">{value}</InputAdornment>,
                            }}
                        />
                        {!hideHeader && (
                            <TextInput
                                backgroundColor="#F2F2F6"
                                height={50}
                                width={'30%'}
                                icon={null}
                                placeholder={textInputPlaceholders?.[1]}
                            />
                        )}
                    </div>
                )}
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 12 }}>
                    {!hideHeader && (
                        <div>
                            <Typography>Recent Activity</Typography>
                            <DateFilter
                                disabled={disabledDateFilter}
                                setFilter={setFilter}
                                filter={filter}
                                defaultValue={dateFilterDefault}
                            />
                        </div>
                    )}
                    {/* <TextInput
                        height={50}
                        backgroundColor="#F2F2F6"
                        sx={{ ml: !showDeleteCell ? 2 : 0, fontSize: 20, fontWeight: 400 }}
                        placeholder={textInputPlaceholders[2]}
                    /> */}
                </div>
                <Table
                    onDeleteClick={onDeleteClick}
                    showDeleteCell={showDeleteCell}
                    successValue="Complete"
                    navigationHandler={navigationHandler}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- pre-existing filter-callback signature
                    loadData={(filters: any) => setFilter && setFilter((pre: any) => ({ ...pre, ...filters }))}
                    defaultPagination={defaultPagination}
                    columns={columns}
                    data={records}
                    onTemplatebuttonclick={onTemplatebuttonclick}
                    getStartedTemplate={getStartedTemplate}
                    templateButtonText={templateButtonText}
                    parentOffset={filter?.offset}
                    loading={loading}
                    serverSidePagination={serverSidePagination}
                    totalCount={totalCount}
                    showLoading={showLoading}
                    emptyMessage={emptyMessage}
                    disableRowNavigation={disableRowNavigation}
                />
            </div>
        </Stack>
    );
}

export default ActivityContainer;
